var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarContentoh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.6001,
    cy: 13,
    r: 12.5,
    fill: "#603888",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62737 12.4168C10.8638 12.4168 11.8661 11.428 11.8661 10.2084C11.8661 8.98873 10.8638 8 9.62737 8C8.39097 8 7.38867 8.98873 7.38867 10.2084C7.38867 11.428 8.39097 12.4168 9.62737 12.4168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3095 12.4168C18.5459 12.4168 19.5482 11.428 19.5482 10.2084C19.5482 8.98873 18.5459 8 17.3095 8C16.0731 8 15.0708 8.98873 15.0708 10.2084C15.0708 11.428 16.0731 12.4168 17.3095 12.4168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 16.2733C7 16.2733 12.8274 18.9271 20 16.2733C20 16.2733 18.5917 20.0002 13.8521 20.0002C9.11244 20.0002 7 16.2733 7 16.2733Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "white",
    transform: "translate(7 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarContentoh);
export default __webpack_public_path__ + "static/media/AvatarContentoh.64b414d15311dc5093c1c96d6b642839.svg";
export { ForwardRef as ReactComponent };